/* script */
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'ToggleBadgePrintingVersion',
    props: {
        value: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        toggle(value) {
            this.$emit('input', value);
        }
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toggle-badge-printing-version" }, [
    _c(
      "button",
      {
        class: { active: _vm.value },
        attrs: { type: "button", title: "Show WYSIWG editor" },
        on: {
          click: function ($event) {
            return _vm.toggle(true)
          },
        },
      },
      [_c("i", { staticClass: "ic-palette" })]
    ),
    _c(
      "button",
      {
        class: { active: !_vm.value },
        attrs: { type: "button", title: "Show old editor" },
        on: {
          click: function ($event) {
            return _vm.toggle(false)
          },
        },
      },
      [_c("i", { staticClass: "ic-code" })]
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-582c00a7_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/**\n    We do not usually do this but\n    as this component is bound to be removed in the near future\n    we avoid CSS left-overs when that happens\n */\n.toggle-badge-printing-version[data-v-582c00a7] {\n    border: 1px solid var(--base-300);\n    border-radius: .4em;\n    display: inline-block;\n    padding: .3em;\n    margin-bottom: 1em;\n}\nbutton[data-v-582c00a7] {\n    padding: .5em;\n    padding-bottom: .3em;\n    font-size: 1.2em;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\nbutton.active[data-v-582c00a7] {\n    border: solid 1px var(--primary-300);\n    border-radius: .4em;\n    color: var(--primary-300);\n    background-color: var(--primary-050);\n}\n", map: {"version":3,"sources":["apps/shared/src/ui/components/editors/design/ToggleBadgePrintingVersion.vue"],"names":[],"mappings":";;;;;;;;;;;;;;;;;;;;;;;;AAwBA;;;;EAIA;AACA;IACA,iCAAA;IACA,mBAAA;IACA,qBAAA;IACA,aAAA;IACA,kBAAA;AACA;AACA;IACA,aAAA;IACA,oBAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;AACA;AACA;IACA,oCAAA;IACA,mBAAA;IACA,yBAAA;IACA,oCAAA;AACA","file":"ToggleBadgePrintingVersion.vue","sourcesContent":["<template lang=\"pug\">\n.toggle-badge-printing-version\n    button(type=\"button\" @click=\"toggle(true)\" title=\"Show WYSIWG editor\" v-bind:class=\"{ 'active': value }\")\n        i.ic-palette\n    button(type=\"button\" @click=\"toggle(false)\" title=\"Show old editor\" v-bind:class=\"{ 'active': !value }\")\n        i.ic-code\n</template>\n<script>\nexport default {\n    name: 'ToggleBadgePrintingVersion',\n    props: {\n        value: {\n            type: Boolean,\n            default: false,\n        }\n    },\n    methods: {\n        toggle(value) {\n            this.$emit('input', value);\n        }\n    },\n};\n</script>\n<style scoped>\n/**\n    We do not usually do this but\n    as this component is bound to be removed in the near future\n    we avoid CSS left-overs when that happens\n */\n.toggle-badge-printing-version {\n    border: 1px solid var(--base-300);\n    border-radius: .4em;\n    display: inline-block;\n    padding: .3em;\n    margin-bottom: 1em;\n}\nbutton {\n    padding: .5em;\n    padding-bottom: .3em;\n    font-size: 1.2em;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\nbutton.active {\n    border: solid 1px var(--primary-300);\n    border-radius: .4em;\n    color: var(--primary-300);\n    background-color: var(--primary-050);\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-582c00a7"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/editors/design/ToggleBadgePrintingVersion.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__